// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';

/* CSS */
import "@css/app.pcss";

/* JS */
import 'lazysizes';
import { gsap } from "gsap";    
import { CustomEase } from "gsap/CustomEase";
import { RoughEase, ExpoScaleEase, SlowMo } from "gsap/EasePack";    
import { Flip } from "gsap/Flip";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { Draggable } from "gsap/Draggable";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { TextPlugin } from "gsap/TextPlugin";
/* The following plugins are Club GSAP perks */
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { ScrambleTextPlugin } from "gsap/ScrambleTextPlugin";
import { SplitText } from "gsap/SplitText";
import { ScrollSmoother } from "gsap/ScrollSmoother";
//import * as YTPlayer from 'yt-player';


/* SCRIPTS HERE */


/**
 * Alpine JS
 * Best to put it last so that all other potential JS is available
 * when components start getting initialized.
 */
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import persist from '@alpinejs/persist';

var duration = duration || 1;
gsap.registerPlugin(Flip,ScrollTrigger,ScrollToPlugin,Draggable,MotionPathPlugin,TextPlugin,ScrollSmoother,DrawSVGPlugin,ScrambleTextPlugin,SplitText,RoughEase,ExpoScaleEase,SlowMo,CustomEase);    

document.addEventListener('alpine:init', () => {

  ScrollSmoother.create({
    smooth: 1,
    effects: true
  });

  // //responsive
  // let mm = gsap.matchMedia();

  // mm.add("(min-width: 768px)", () => {
  //   ScrollTrigger.create({
  //     trigger: ".footer",
  //     pin: true,
  //     start: "bottom bottom",
  //     end: "+=100%"
  //   });
  // });

  // let footer = document.querySelector("footer"),
  // getOverlap = () => Math.min(window.innerHeight, footer.offsetHeight), // we never want it to overlap more than the height of the screen
  // adjustFooterOverlap = () => footer.style.marginTop = -getOverlap() + "px"; // adjusts the margin-top of the footer to overlap the proper amount

  // adjustFooterOverlap();

  // // to make it responsive, re-calculate the margin-top on the footer when the ScrollTriggers revert
  // ScrollTrigger.addEventListener("revert", adjustFooterOverlap);

  // // magic
  // ScrollTrigger.create({
  //   trigger: footer,
  //   start: () => "top " + (window.innerHeight - getOverlap()),
  //   end: () => "+=" + getOverlap(),
  //   pin: true,
  // });

  var split = new SplitText(".heading .header-main-text", {type: "words", tag: 'span',  linesClass:"", wordsClass:"word animate word-++"});
  var imgTitleSplit = new SplitText(".img-title", {type: "lines, words", tag: 'span',  linesClass:"", wordsClass:"word animate word-++"});

  Alpine.data('sectionStandard', (animateContent, staggerAnimations) => ({
    init() {       
      if (animateContent) {
        const animParent = this.$refs.animparent;
        const animSelector = "#" + animParent.getAttribute('id') + " .animate" ;
        const animCast = document.querySelectorAll(animSelector);
        gsap.set(animCast, {
          opacity: 0,
          y: -35
        })
        if (staggerAnimations) {          
          ScrollTrigger.batch(animCast, {
            onEnter: batch => gsap.to(batch, 
            {
              duration: duration * 1,		
              y: 0,
              opacity: 1,
              // Note: Easing Pack required for easing
              ease: "back.inOut",
              onComplete() {
                this.postRevealFunction;
              },
              stagger: 0.1			
            }),
            start: "top 80%",
            once: true
          });
        } else {
          animCast.forEach(animItem => {              
            gsap.from(animItem, { 			
              duration: duration * 1,
              y: -35,			
              opacity: 0,              			
              // Note: Easing Pack required for easing
              ease: "back.inOut",
              onComplete: this.postRevealFunction,              	
              scrollTrigger: {
                trigger: animParent,
                start: "top 80%",
              }			
            })
          });
        }
      } else {
        const animElem = this.$refs.animate;
        gsap.from(animElem, {
          duration: duration * 1,
          y: 50,          
          opacity: 0,			
          // Note: Easing Pack required for easing
          ease: "back.inOut",
          onComplete: this.postReveal,          			
          scrollTrigger: {
            trigger: animElem,
            start: "top 80%",
          }
        })  
      }           
    },
        
    postReveal() {
      
    }    
      
  })),
  
  Alpine.data('sectionSidePhoto', (animateContent, staggerAnimations) => ({
  init() {
      if (animateContent) {
        const animParent = this.$refs.animparent;
        const animSelector = "#" + animParent.getAttribute('id') + " .animate" ;
        const animCast = document.querySelectorAll(animSelector);
        gsap.set(animCast, {
          opacity: 0,
          x: -35
        })
        if (staggerAnimations) {          
          ScrollTrigger.batch(animCast, {
            onEnter: batch => gsap.to(batch, 
            {
              duration: duration * 1,		
              x: 0,
              opacity: 1,
              // Note: Easing Pack required for easing
              ease: "back.inOut",
              onComplete() {
                this.postRevealFunction;
              },
              stagger: 0.1			
            }),
            start: "top 80%",
            once: true
          });
          gsap.from('.word-26', {duration: 1, color: '#00b7ec', ease: 'expo.out'}, '+=0.5'); 
        } else {
          animCast.forEach(animItem => {              
            gsap.from(animItem, { 			
              duration: duration * 1,
              y: -35,			
              opacity: 0,              			
              // Note: Easing Pack required for easing
              ease: "back.out",
              onComplete: this.postRevealFunction,              	
              scrollTrigger: {
                trigger: animParent,
                start: "top 80%",
              }			
            })
          });
        }
      } else {
        const animElem = this.$refs.animate;
        gsap.from(animElem, {
          duration: duration * 1,
          y: 50,          
          opacity: 0,			
          // Note: Easing Pack required for easing
          ease: "back.inOut",
          onComplete: this.postReveal,          			
          scrollTrigger: {
            trigger: animElem,
            start: "top 80%",
          }
        })  
      }                
    },
          
    postReveal() {
        
    }    
        
  }))
    
})

if (typeof window.Alpine === "undefined") {
  Alpine.plugin(collapse);
  Alpine.plugin(focus);
  Alpine.plugin(persist);
  window.Alpine = Alpine;
  window.Swiper = Swiper;  
  Alpine.start();
}


// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
  import.meta.hot.accept(() => {
	console.log("HMR")
  });
}

